"use client";

import { useEffect } from "react";

import { readPersistedAuthSession } from "@/feature/auth/lib/auth-session";
import { hydrateFromStorage, setHydrated } from "@/feature/auth/state/auth-slice";
import { useAppDispatch } from "@/redux/hooks";

export function AuthBootstrap() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      const session = await readPersistedAuthSession();
      if (!isMounted) {
        return;
      }

      if (session) {
        dispatch(hydrateFromStorage(session));
        return;
      }

      dispatch(setHydrated(true));
    })();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return null;
}
